module.exports = __webpack_public_path__ + "img/heavy-lifting-scaled.feac3e7b.jpg";